export const GET_TASKCATEGORIES_BEGIN='GET_TASKCATEGORIES_BEGIN'
export const GET_TASKCATEGORIES_SUCCESS='GET_TASKCATEGORIES_SUCCESS'
export const GET_TASKCATEGORIES_ERROR='GET_TASKCATEGORIES_ERROR'

export const DELETE_TASKCATEGORY_BEGIN='DELETE_TASKCATEGORY_BEGIN'
export const DELETE_TASKCATEGORY_SUCCESS='DELETE_TASKCATEGORY_SUCCESS'
export const DELETE_TASKCATEGORY_ERROR = 'DELETE_TASKCATEGORY_ERROR'

export const CREATE_TASKCATEGORY_BEGIN = 'ADD_TASKCATEGORY_BEGIN'
export const CREATE_TASKCATEGORY_SUCCESS = 'ADD_TASKCATEGORY_SUCCESS'
export const CREATE_TASKCATEGORY_ERROR = 'ADD_TASKCATEGORY_ERROR'

export const UPDATE_TASKCATEGORY_BEGIN = 'UPDATE_TASKCATEGORY_BEGIN'
export const UPDATE_TASKCATEGORY_SUCCESS = 'UPDATE_TASKCATEGORY_SUCCESS'
export const UPDATE_TASKCATEGORY_ERROR = 'UPDATE_TASKCATEGORY_ERROR'